"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayMove = void 0;
function arrayMove(array, fromIndex, toIndex) {
    var item = array[fromIndex];
    array.splice(fromIndex, 1);
    array.splice(toIndex, 0, item);
}
exports.arrayMove = arrayMove;
